

// import johnMaesaka from "../../assets/Pannel Members/john.jpg";
// import consolatoSergi from "../../assets/Pannel Members/consolato.jpg";
// import saadTayyab from "../../assets/Pannel Members/saad.jpg";
// import berndBlobel from "../../assets/Pannel Members/bernd.jpg";
// import murrayMooYoung from "../../assets/Pannel Members/murray.jpg";
// import valasiaIakovoglou from "../../assets/Pannel Members/valasia.jpg";
// import vladlenSlepak from "../../assets/Pannel Members/vladlen.jpg";
// import yongXiaoWang from "../../assets/Pannel Members/yong.jpg";

// import johnMaesaka_banner from "../../assets/Pannel Banners/john_banner.jpg";
// import consolatoSergi_banner from "../../assets/Pannel Banners/consolato_banner.jpg";
// import saadTayyab_banner from "../../assets/Pannel Banners/saad_banner.jpg";
// import berndBlobel_banner from "../../assets/Pannel Banners/bernd_banner.jpg";
// import murrayMooYoung_banner from "../../assets/Pannel Banners/murray_banner.jpg";
// import valasiaIakovoglou_banner from "../../assets/Pannel Banners/valasia_banner.jpg";
// import vladlenSlepak_banner from "../../assets/Pannel Banners/vladlen_banner.jpg";
// import yongXiaoWang_banner from "../../assets/Pannel Banners/yong_banner.jpg";

// export const panel_members_about = [
//   {
//     id: "john-maesaka",
//     image: johnMaesaka,
//     name: "Dr. John K. Maesaka",
//     from: "USA",
//     about: "NYU Grossman Long Island School of Medicine",
//     link: "/executive-panel-members/john-maesaka",
//   },
//   {
//     id: "consolato-sergi",
//     image: consolatoSergi,
//     name: "Dr. Consolato Sergi",
//     from: "Canada",
//     about: "University of Alberta and Ottawa",
//     link: "/executive-panel-members/consolato-sergi",
//   },
//   {
//     id: "saad-tayyab",
//     image: saadTayyab,
//     name: "Dr. Saad Tayyab",
//     from: "Malaysia",
//     about: "UCSI University, Kuala Lumpur",
//     link: "/executive-panel-members/saad-tayyab",
//   },
//   {
//     id: "bernd-blobel",
//     image: berndBlobel,
//     name: "Dr. Bernd Blobel",
//     from: "Germany",
//     about: "University of Magdeburg",
//     link: "/executive-panel-members/bernd-blobel",
//   },
//   // {
//   //   id: "murray-moo-young",
//   //   image: murrayMooYoung,
//   //   name: "Prof. Murray Moo-Young",
//   //   from: "Canada",
//   //   about: "University of Waterloo",
//   //   link: "/executive-panel-members/murray-moo-young",
//   // },
//   // {
//   //   id: "valasia-iakovoglou",
//   //   image: valasiaIakovoglou,
//   //   name: "Dr. Valasia Iakovoglou",
//   //   from: "USA",
//   //   about: "Iowa State University",
//   //   link: "/executive-panel-members/valasia-iakovoglou",
//   // },
//   // {
//   //   id: "vladlen-slepak",
//   //   image: vladlenSlepak,
//   //   name: "Dr. Vladlen Slepak",
//   //   from: "USA",
//   //   about: "University of Miami Miller School of Medicine",
//   //   link: "/executive-panel-members/vladlen-slepak",
//   // },
//   // {
//   //   id: "yong-xiao-wang",
//   //   image: yongXiaoWang,
//   //   name: "Dr. Yong Xiao Wang",
//   //   from: "USA",
//   //   about: "Albany Medical College",
//   //   link: "/executive-panel-members/yong-xiao-wang",
//   // },
// ];

// export const panel_members = panel_members_about;

// export const john_maesaka_data = {
//   image: johnMaesaka,
//   name: "Dr. John K. Maesaka",
//   from: "NYU Grossman Long Island School of Medicine, USA",
//   about:
//     "John Maesaka, professor of medicine at NYU Grossman Long Island School of Medicine and Chief Emeritus, Division of Nephrology and Hypertension at the NYU Langone Hospital Long Island. He received a BA degree from Harvard University, MD from Boston University School of Medicine, and trained at Barnes Jewish Hospital, Mount Sinai Hospital, and Medical School N.Y. He spent 5 years in a physiology lab at Mount Sinai Medical Center which prepared him for his future research.",
//   banner: johnMaesaka_banner,
//   link: "/executive-panel-members/john-maesaka",
// };

// export const consolato_sergi_data = {
//   image: consolatoSergi,
//   name: "Dr. Consolato Sergi",
//   from: "University of Alberta and Ottawa, Canada",
//   about:
//     "Dr. Sergi is the Chief of the Anatomic Pathology Division at the Children’s Hospital of Eastern Ontario, and Professor of Pediatrics and Pathology at the University of Alberta and Ottawa, Canada. Canadian, born in Rome (Italy), he earned his MD with honors and a Pediatric Pathology Fellowship from the University of Genoa, Italy.",
//   banner: consolatoSergi_banner,
//   link: "/executive-panel-members/consolato-sergi",
// };

// export const saad_tayyab_data = {
//   image: saadTayyab,
//   name: "Dr. Saad Tayyab",
//   from: "UCSI University, Kuala Lumpur, Malaysia",
//   about:
//     "Dr. Saad Tayyab studied Biochemistry at Aligarh Muslim University, India, completing Masters and Ph.D. degrees in 1981 and 1987, respectively. He is currently working as a Professor of Pharmaceutical Chemistry at UCSI University, Kuala Lumpur, Malaysia. Before joining UCSI University, Dr. Saad served at Universiti Malaya (2004-2018), Haramaya University, Ethiopia (2001-2004), Aligarh Muslim University, India (1988-2001), and the University of Kashmir, India (1987-1988). He was admitted as a Fellow, Royal Society of Chemistry, UK, in 2017, Fellow, Royal Society of Biology, UK, in 2019, Member, American Chemical Society in 2020, and Member, Sigma Xi in 2024.  journals.",
//   banner: saadTayyab_banner,
//   link: "/executive-panel-members/saad-tayyab",
// };

// export const bernd_blobel_data = {
//   image: berndBlobel,
//   name: "Dr. Bernd Blobel",
//   from: "University of Magdeburg, Germany",
//   about:
//     "Dr. Bernd Blobel studied Mathematics, Technical Cybernetics and Electronics, Bio-Cybernetics, Physics, Medicine and Informatics at the University of Magdeburg and other universities in the former GDR. He received his PhD in Physics with a neurophysiological study. Furthermore, he performed the Habilitation (qualification as university professor) in Medicine and Informatics.",
//   banner: berndBlobel_banner,
//   link: "/executive-panel-members/bernd-blobel",
// };

// export const murray_moo_young_data = {
//   image: murrayMooYoung,
//   name: "Prof. Murray Moo-Young",
//   from: "University of Waterloo, Canada",
//   about:
//     "Distinguished Professor Emeritus at the University of Waterloo. Educated at London (PhD), Toronto (MSc), and Edinburgh (Postdoc). He’s received awards from ACS, AIMBE, IUPAC, UNESCO, and others for bioengineering research.",
//   banner: murrayMooYoung_banner,
//   link: "/executive-panel-members/murray-moo-young",
// };

// export const valasia_iakovoglou_data = {
//   image: valasiaIakovoglou,
//   name: "Dr. Valasia Iakovoglou",
//   from: "Iowa State University, USA",
//   about:
//     "Dr. Iakovoglou has 25+ years of global experience as an ecophysiologist. Expert in seedling production, biodiversity, climate change. She’s a reviewer/editor of over 25 journals and an IPCC reviewer.",
//   banner: valasiaIakovoglou_banner,
//   link: "/executive-panel-members/valasia-iakovoglou",
// };

// export const vladlen_slepak_data = {
//   image: vladlenSlepak,
//   name: "Dr. Vladlen Slepak",
//   from: "University of Miami Miller School of Medicine, USA",
//   about:
//     "Dr. Slepak studied Biology in Moscow and earned his PhD in Bioorganic Chemistry. He has published 80+ papers on G protein signaling. Professor at University of Miami since 1995.",
//   banner: vladlenSlepak_banner,
//   link: "/executive-panel-members/vladlen-slepak",
// };

// export const yong_xiao_wang_data = {
//   image: yongXiaoWang,
//   name: "Dr. Yong Xiao Wang",
//   from: "Albany Medical College, USA",
//   about:
//     "Full Professor since 2006. Holds MD, PhD, and postdoc training. Funded by NIH, AHA, ADA, and others. Published in Nature, PNAS, Circ Res, etc. Active on journal boards and scientific committees.",
//   banner: yongXiaoWang_banner,
//   link: "/executive-panel-members/yong-xiao-wang",
// };

// export const epms_details_map = {
//   "john-maesaka": john_maesaka_data,
//   "consolato-sergi": consolato_sergi_data,
//   "saad-tayyab": saad_tayyab_data,
//   "bernd-blobel": bernd_blobel_data,
//   "murray-moo-young": murray_moo_young_data,
//   "valasia-iakovoglou": valasia_iakovoglou_data,
//   "vladlen-slepak": vladlen_slepak_data,
//   "yong-xiao-wang": yong_xiao_wang_data,
// };



import philipKim from "../../assets/Pannel Members/philip-kim.jpg";
import stevenLouie from "../../assets/Pannel Members/steven-louie.jpg";
import kameshGupta from "../../assets/Pannel Members/kamesh-gupta.jpg";
import sivasambuBohm from "../../assets/Pannel Members/sivasambu-bohm.jpg";
import andreaFerrari from "../../assets/Pannel Members/andrea-ferrari.jpg";
import hyunJongChung from "../../assets/Pannel Members/hyun-jong-chung.jpg";
import sadeghKamaeiBahmaei from "../../assets/Pannel Members/sadegh-kamaei-bahmaei.jpg";
import rezalKhairiAhmad from "../../assets/Pannel Members/rezal-khairi-ahmad.jpg";
import aliAlSamydai from "../../assets/Pannel Members/ali-al-samydai.jpg";
import sinaMatalqah from "../../assets/Pannel Members/sina-matalqah.jpg";

import philipKim_banner from "../../assets/Pannel Banners/philip-kim_banner.jpg";
import stevenLouie_banner from "../../assets/Pannel Banners/steven-louie_banner.jpg";
import kameshGupta_banner from "../../assets/Pannel Banners/kamesh-gupta_banner.jpg";
import sivasambuBohm_banner from "../../assets/Pannel Banners/sivasambu-bohm_banner.jpg";
import andreaFerrari_banner from "../../assets/Pannel Banners/andrea-ferrari_banner.jpg";
import hyunJongChung_banner from "../../assets/Pannel Banners/hyun-jong-chung_banner.jpg";
import sadeghKamaeiBahmaei_banner from "../../assets/Pannel Banners/sadegh-kamaei-bahmaei_banner.jpg";
import rezalKhairiAhmad_banner from "../../assets/Pannel Banners/rezal-khairi-ahmad_banner.jpg";
import aliAlSamydai_banner from "../../assets/Pannel Banners/ali-al-samydai_banner.jpg";
import sinaMatalqah_banner from "../../assets/Pannel Banners/sina-matalqah_banner.jpg";


export const panel_members_about = [
  {
    id: "philip-kim",
    image: philipKim,
    name: "Philip Kim",
    from: "Harvard University, USA", // Shortened
    about: "Condensed Matter Physicist", // Shortened
    link: "/executive-panel-members/philip-kim",
  },
  {
    id: "steven-louie",
    image: stevenLouie,
    name: "Steven Louie",
    from: "UC Berkeley, USA", // Shortened
    about: "Condensed Matter Physicist", // Shortened
    link: "/executive-panel-members/steven-louie",
  },
  {
    id: "kamesh-gupta",
    image: kameshGupta,
    name: "Kamesh Gupta",
    from: "India Graphene Engg. Centre, India", // Shortened
    about: "New Materials (Graphene) Expert", // Shortened
    link: "/executive-panel-members/kamesh-gupta",
  },
  {
    id: "sivasambu-bohm",
    image: sivasambuBohm,
    name: "Sivasambu Bohm",
    from: "Graph-Nova & Imperial College London", // Shortened
    about: "Nanotechnology R&D, Graphene", // Shortened
    link: "/executive-panel-members/sivasambu-bohm",
  },
  {
    id: "andrea-ferrari",
    image: andreaFerrari,
    name: "Andrea Ferrari",
    from: "Cambridge Graphene Centre, UK", // Shortened
    about: "Professor of Nanotechnology", // Shortened
    link: "/executive-panel-members/andrea-ferrari",
  },
  {
    id: "hyun-jong-chung",
    image: hyunJongChung,
    name: "Hyun-Jong Chung",
    from: "A Barristor Company, South Korea", // Shortened
    about: "CEO, Graphene Electronics", // Shortened
    link: "/executive-panel-members/hyun-jong-chung",
  },
  {
    id: "sadegh-kamaei-bahmaei",
    image: sadeghKamaeiBahmaei,
    name: "Sadegh Kamaei Bahmaei",
    from: "Melexis, Switzerland", // Shortened
    about: "Engineer, Microelectronics", // Shortened
    link: "/executive-panel-members/sadegh-kamaei-bahmaei",
  },
  {
    id: "rezal-khairi-ahmad",
    image: rezalKhairiAhmad,
    name: "Rezal Khairi Ahmad",
    from: "NanoMalaysia Berhad, Malaysia", // Shortened
    about: "CEO, Nanotechnology", // Shortened
    link: "/executive-panel-members/rezal-khairi-ahmad",
  },
  {
    id: "ali-al-samydai",
    image: aliAlSamydai,
    name: "Ali Al-Samydai",
    from: "Al-Ahliyya Amman University, Jordan", // Shortened
    about: "Nanophytosome Drug Delivery", // Shortened
    link: "/executive-panel-members/ali-al-samydai",
  },
  {
    id: "sina-matalqah",
    image: sinaMatalqah,
    name: "Sina Matalqah",
    from: "Al-Ahliyya Amman University, Jordan", // Shortened
    about: "Nanotechnology Drug Delivery", // Shortened
    link: "/executive-panel-members/sina-matalqah",
  },
];

export const panel_members = panel_members_about;

export const philip_kim_data = {
  image: philipKim,
  name: "Philip Kim",
  from: "Harvard University, USA",
  about:
    "Philip Kim is an experimental condensed matter physicist. The focus of Kim group’s research is the mesoscopic investigation of various physical phenomena in low dimensional and nanostructured materials. In a nanoscaled material, effectively reduced dimensionality of the electron system yields enhanced quantum effects and increased correlation effects due to the reduction of available phase space. The low dimensional materials the Kim group is working on include 2-dimensional mesoscopic crystals, 1-dimensional nanowires and nanotubes, and single organic and inorganic molecular crystals. The use of modern state-of-the-art device fabrication techniques and the development of novel material synthesis/manipulation methods are essential parts of our research. The current research topics are: quantum transport in graphene and its heterostructures; developing heterostructured van der Waals material interfaces; mesoscale investigation physics of correlated materials; and quantum engineered thermoelectric/ thermal transport.",
  banner: philipKim_banner,
  link: "/executive-panel-members/philip-kim",
};

export const steven_louie_data = {
  image: stevenLouie,
  name: "Steven Louie",
  from: "UC Berkeley, USA",
  about:
    "Steven G. Louie received his Ph.D. in physics from UC Berkeley in 1976. After having worked at the IBM Watson Research Center, Bell Laboratories, and University of Pennsylvania, he joined the UC Berkeley faculty in 1980. He is a member of the National Academy of Sciences (2005), fellow of the American Physical Society (1985), senior faculty scientist and Theory Facility Director of the Molecular Foundry at LBNL, and editor of the journal Solid State Communications. He has been awarded a Sloan Fellowship (1980), a Guggenheim Fellowship (1989), two Miller Professorships (1986, 1995), the U.S. Department of Energy Award for Sustained Outstanding Research in Solid State Physics (1993), the Lawrence Berkeley National Laboratory’s Outstanding Performance Award (1995), the Aneesur Rahman Prize for Computational Physics of the American Physical Society (1996), the Davisson-Germer Prize in Surface Physics of the American Physical Society (1999), and shared with M. L. Cohen the Foresight Institute Richard P. Feynman Prize in Nanotechnology (2003). He is identified by the ISI as one of the most highly cited researchers in physics.",
  banner: stevenLouie_banner,
  link: "/executive-panel-members/steven-louie",
};

export const kamesh_gupta_data = {
  image: kameshGupta,
  name: "Kamesh Gupta",
  from: "India Graphene Engineering & Innovation Centre, India",
  about:
    "Experienced professional with decades of multi sectoral, domestic and international experience across New Materials (Graphene and Medical Materials), Aerospace & Defence, Industrial & Automotive, Technology & Innovation, Public Affairs & Government relations and Startups. Business management and strategic leadership in Collaborations and Joint Ventures, Strategy, Bi-lateral alliances, Technology transfers, Innovation, Technology programs, Start-up engagement, Strategic sourcing, Business Development, Exports and P&L. Contribution across geographies; US, UK & Scotland, Russia, Europe, Canada, Japan, South Africa, Singapore, Germany & South Korea. At Tata Steel - New Material Business - Commercialized Graphene Technology and established first Advance Ceramic JV. Created high impact global collaboration with Government, Academia and bi-lateral alliance (UK & Germany). At Tata Sons Group Technology & Innovation Office - Delivered Strategic collaborations & Technology programs, building a Technology ecosystem, bringing in best of Industry including Tata group companies, global players, start-ups, labs & the government to curate strategic Industrial & social impact programs. Held several executive positions across Tata companies in key roles, Chief - Graphene Business, Medical Materials, Innoventure and Innovation - Tata Steel, Senior Vice President - Group Technology and Innovation - Tata Sons, Chief Operating Officer of Tata’s Aerospace & Defence start-up - Tata Industries, as Vice President – Public Affairs at Tata Services, Chief of Sales & Exports, Chief of Supply chain, Head of Marketing & Business Development at Tata Hitachi; a subsidiary of Tata Motors Ltd. Resourceful, innovative, versatile, adaptable and transformational leader, committed to social causes and climate change. Mechanical Engineer with Management Education from the Indian Institute of Management Ahmedabad, and a Chevening fellow from the University of Oxford.",
  banner: kameshGupta_banner,
  link: "/executive-panel-members/kamesh-gupta",
};

export const sivasambu_bohm_data = {
  image: sivasambuBohm,
  name: "Sivasambu Bohm",
  from: "Graph-Nova & Imperial College London, China",
  about:
    "At the forefront of nanotechnology R&D, my work revolutionises materials application in the automotive and construction sectors, focusing on graphene and carbon nanomaterials. With over 30 years of research experience, our team successfully integrates cutting-edge innovations into market-leading companies like BYD and CATL, enhancing their product performance and sustainability. As a part-time chief scientific executive, I spearhead the development of value-added products, particularly in energy storage and nanocoatings. My expertise in advanced Li-Ion battery additives and energy storage components has contributed to the growth of our company portfolio while our research initiatives continue to set new benchmarks for environmentally friendly technologies in the industry.",
  banner: sivasambuBohm_banner,
  link: "/executive-panel-members/sivasambu-bohm",
};

export const andrea_ferrari_data = {
  image: andreaFerrari,
  name: "Andrea Ferrari",
  from: "Cambridge Graphene Centre / University of Cambridge, UK",
  about:
    "Andrea C. Ferrari earned a PhD in electrical engineering from Cambridge University, after a Laurea in nuclear engineering from Politecnico di Milano, Italy. He is Professor of nanotechnology and Professorial Fellow of Pembroke College. He founded and directs the Cambridge Graphene Centre and the EPSRC Centre for Doctoral Training in Graphene Technology. He chairs the management panel and is the Science and Technology Officer of the European Graphene Flagship. He is a Fellow of the American Physical Society, Fellow of the Materials Research Society, Fellow of the Institute of Physics, Fellow of the Optical Society and he has been recipient of numerous awards, such as the Royal Society Brian Mercer Award for Innovation, the Royal Society Wolfson Research Merit Award, the Marie Curie Excellence Award, the Philip Leverhulme Prize, The EU-40 Materials Prize. He also received 4 European Research Council Grants.",
  banner: andreaFerrari_banner,
  link: "/executive-panel-members/andrea-ferrari",
};

export const hyun_jong_chung_data = {
  image: hyunJongChung,
  name: "Hyun-Jong Chung",
  from: "A Barristor Company, South Korea",
  about:
    "Hyun-jong Chung, CEO of A Barristor Company, holds a Ph.D in physics and has been researching graphene electronics since joining the Samsung Advanced Institute of Technology in 2006. He developed 6-inch wafer scale graphene-related processes to fabricate graphene RF transistors, and developed low-noise amplifiers using these transistors. To address the problem of graphene field-effect transistors that cannot be switched off due to the absence of a band gap, he invented a new electronic device that modulates the height of the graphene-Si Schottky barrier, published his findings in Science, and patented the device, which he named Barristor. He then moved to Konkuk University and continued to research barristor-based sensor electronics with dramatically higher response/sensitivity than conventional devices, and founded A Barristor Company to commercialize them. Graphene barristors can be adapted for a variety of sensors, from biosensors to photodetectors to gas detectors, by simply changing the doping materials on the graphene surface while maintaining the same device structure. A Barristor Company plans to develop this technology into a platform sensor service.",
  banner: hyunJongChung_banner,
  link: "/executive-panel-members/hyun-jong-chung",
};

export const sadegh_kamaei_bahmaei_data = {
  image: sadeghKamaeiBahmaei,
  name: "Sadegh Kamaei Bahmaei",
  from: "Melexis, Switzerland",
  about:
    "A highly motivated, ambitious, and extremely curious engineer, driven by a lifelong passion for leveraging technology to create meaningful change. I am constantly looking for new ways to apply my scientific mindset to positively impact our society. With over 5 years of international experience in developing and characterizing energy-efficient and cutting-edge technologies and a Ph.D. in Microelectronics and Microsystems from EPFL (laureate of the doctoral school thesis distinction), I bring valuable insights into the development of innovative solutions in sensors and personalized healthcare sectors. My expertise spans biosensors, technology development, electronic devices, electrical/electrochemical characterizations, and material analysis, providing me with a robust engineering foundation. I have actively participated in multidisciplinary projects ranging from personalized healthcare to the semiconductor devices. Collaborating with global universities, hospitals, industries, and startups has honed my ability to operate in diverse environments and communicate effectively across various cultures.",
  banner: sadeghKamaeiBahmaei_banner,
  link: "/executive-panel-members/sadegh-kamaei-bahmaei",
};

export const rezal_khairi_ahmad_data = {
  image: rezalKhairiAhmad,
  name: "Rezal Khairi Ahmad",
  from: "NanoMalaysia Berhad, Malaysia",
  about:
    "Dr. Rezal was appointed as the Chief Executive Officer of NanoMalaysia in January 2013. Dr Rezal holds a Ph.D. in Nanotechnology, Electronic/Electrical Engineering from London Centre for Nanotechnology, University College London as the first Khazanah Ph.D. Scholar. As NanoMalaysia’s first employee, he crafted the company structure and developed the business model and corporate positioning strategy relative to like-minded government agencies and relevant industries. Between August 2012 and February 2013, Dr. Rezal also served as Acting Under Secretary of National Nanotechnology Directorate, Ministry of Science, Technology and Innovation (MOSTI). From June 2012 to May 2014, he came under secondment from Khazanah Nasional, an investment arm of the Government of Malaysia. Prior to that, he was a Manager at GEMS Sdn. Bhd. and Business Development Manager in a local ICT private company from 2000 to 2001.",
  banner: rezalKhairiAhmad_banner,
  link: "/executive-panel-members/rezal-khairi-ahmad",
};

export const ali_al_samydai_data = {
  image: aliAlSamydai,
  name: "Ali Al-Samydai",
  from: "Associate Professor, Al-Ahliyya Amman University, Jordan.",
  about:
    "Dr Ali Mahmoud Al-Samydai PhD Nanophytosome (Nano-based drug delivery systems) Associate Professor at Al-Ahliyya Amman University, Faculty of Pharmacy, Department of pharmaceutical and pharmaceutical technology, interested in developing novel Nanoliposmes and Nanophytosome models, resulting in a formulation having higher activities by promoted pharmacokinetic and pharmacodynamic properties compared to the conventional drugs and herbal extracts, Currently, Dr Al-Samydai investigating anti-cancer, anti-inflammatory and wound healing activities of a novel model of encapsulated phytoconstituents in Lipid-based nanoparticles. He published 60 articles in the field of pharmaceutical sciences and pharmaceutical technology, and 51 articles indexed in SCOPUS from 2019-2024.",
  banner: aliAlSamydai_banner,
  link: "/executive-panel-members/ali-al-samydai",
};

export const sina_matalqah_data = {
  image: sinaMatalqah,
  name: "Sina Matalqah",
  from: "Assistant Professor, Al-Ahliyya Amman University, Jordan",
  about:
    "Dr. Sina Matalqah (Nanotechnology Drug Delivery Systems). Assistance professor at Al-Ahliyya Amman University, Faculty of Pharmacy, Department of Pharmaceutical and Pharmaceutical Technology. Dr. Matalqah has her expertise in preparation and evaluation of Chitosan Nanoparticles (NPs) and Metal NPs especially Silver NPs (AgNO3), loaded with either drugs or plant extract resulting a novel formulations having higher activities compared to the conventional drugs and herbal extract. Nowadays Dr. Matalqah investigating anti-cancer, anti-bacterial and wound healing activities of different plant extract loaded in different types of NPs.",
  banner: sinaMatalqah_banner,
  link: "/executive-panel-members/sina-matalqah",
};


export const epms_details_map = {
  "philip-kim": philip_kim_data,
  "steven-louie": steven_louie_data,
  "kamesh-gupta": kamesh_gupta_data,
  "sivasambu-bohm": sivasambu_bohm_data,
  "andrea-ferrari": andrea_ferrari_data,
  "hyun-jong-chung": hyun_jong_chung_data,
  "sadegh-kamaei-bahmaei": sadegh_kamaei_bahmaei_data,
  "rezal-khairi-ahmad": rezal_khairi_ahmad_data,
  "ali-al-samydai": ali_al_samydai_data,
  "sina-matalqah": sina_matalqah_data,
};